module.exports = __webpack_public_path__ + "img/1.d6070d3c.png";